export default "__VITE_ASSET__0694f1b7__"